import { connect } from 'react-redux';
import UserManualTab from './UserManualTab';
import {
  addOrEditChapter,
  addOrEditManual,
  chaptersInit,
  deleteChapter,
  deleteManual,
  getListChapters,
  moveChapter,
  moveManual,
  videoViewerOpen
} from '../../store/actions/userManual';
import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = ({
  userManualReducer,
  userReducer
}) => ({
  userManualReducer,
  userReducer
});
const mapDispatchToProps = {
  addOrEditChapter,
  addOrEditManual,
  chaptersInit,
  deleteChapter,
  deleteManual,
  getListChapters,
  modalErrorOpen,
  moveChapter,
  moveManual,
  videoViewerOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManualTab);
